import { useState, CSSProperties } from "react";

interface ImageWithLoaderProps {
    src: string;
    alt: string;
    style?: CSSProperties;
    onClick?: () => void;
}
const loadingSVG = `
<svg xmlns='http://www.w3.org/2000/svg' width='125' height='72'>
  <rect width='100%' height='100%' fill='#eee'/>
  <text x='50%' y='50%' font-family='sans-serif' font-size='14'
        text-anchor='middle' alignment-baseline='middle' fill='#999'>
    Loading…
  </text>
</svg>
`;
const loadingBase64 = `data:image/svg+xml;utf8,${encodeURIComponent(loadingSVG)}`;
const ImageWithLoader = ({ src, alt, style, onClick }: ImageWithLoaderProps) => {
    const [loading, setLoading] = useState(true);
    return (
        <div style={{ position: "relative", overflow: "hidden", }} onClick={onClick}>
            {loading && (
                <img src={loadingBase64} style={{ position: "absolute", width: "100%", height: "100%", objectFit: "cover", filter: "blur(5px)", }} alt="placeholder" />
            )}

            <img
                src={src}
                alt={alt}
                loading="lazy"
                style={{
                    ...style,
                    width: "100%",
                    // height: "65px",
                    objectFit: "contain",
                    opacity: loading ? 0 : 1,
                    transition: "opacity 0.3s ease-in-out",
                }}
                onLoad={() => setLoading(false)}
                onError={() => setLoading(false)}
            />
        </div>
    );
};

export default ImageWithLoader;
